var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretDownRed = function SvgCaretDownRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    fill: "none",
    viewBox: "0 0 17 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9E3039",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M15.333 2 8.981 7.88a.45.45 0 0 1-.314.12.48.48 0 0 1-.314-.12L2 2"
  })));
};
export { SvgCaretDownRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjMzMzMgMkw4Ljk4MDc0IDcuODc5NDdDOC45Mzk1MiA3LjkxNzY4IDguODkwNTYgNy45NDc5OSA4LjgzNjY3IDcuOTY4NjdDOC43ODI3NyA3Ljk4OTM1IDguNzI1MDEgOCA4LjY2NjY3IDhDOC42MDgzMiA4IDguNTUwNTYgNy45ODkzNSA4LjQ5NjY2IDcuOTY4NjdDOC40NDI3NyA3Ljk0Nzk5IDguMzkzODIgNy45MTc2OCA4LjM1MjU5IDcuODc5NDdMMiAyIiBzdHJva2U9IiM5RTMwMzkiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";